<template>
<div class="main mt15">
	<div class="banner">
		<img src="/static/images/haierProduct/truckEmployer/by_car.jpg" alt="">
		<div class="banner-container">
			<div class="banner-container-title">货车雇主责任险</div>
			<div class="banner-container-case">—  按车投保  —</div>
			<Form 
				class="banner-container-input" 
				:model="form" 
				ref="form"
				:label-width="0"
				@submit.native.prevent
				:rules="rules">
				<Form-item prop="code">
					<Input placeholder="请填写V码/9码" v-model="form.code" :maxlength="20" />
				</Form-item>
				<Form-item prop="scheme">
					<Select v-model="form.scheme" placeholder="请选择方案">
						<Option value="扩展版（50+5万）">扩展版（50+5万）</Option>
						<Option value="扩展版（80+10万）">扩展版（80+10万）</Option>
						<Option value="扩展版（100+15万）">扩展版（100+15万）</Option>
					</Select>
				</Form-item>
			</Form>
			<div class="banner-container-btn">
				<a class="btn" @click="sub">立即购买</a>
				<p class="notes">如有问题请联系：<span class="red">0532-88931683</span></p>
			</div>
		</div>
	</div>
	<div class="tabs" ref="tabs">
		<div class="tabs-container" :class="{fixed:fixed}">
			<Tabs :value="tabName" @on-click="tabChange">
				<TabPane label="方案简介" name="case"></TabPane>
				<TabPane label="理赔流程" name="claim"></TabPane>
				<TabPane label="常见问题" name="question"></TabPane>
			</Tabs>
			<div class="tabs-container-form" v-show="fixed">
				<Form 
					:model="form" 
					ref="fixedForm"
					:label-width="0"
					:rules="rules"
					 style="width:450px;display:inline-block">
					<Form-item prop="code" style="width:200px;display:inline-block">
						<Input placeholder="请填写V码/9码" v-model="form.code" :maxlength="20"/>
					</Form-item>
					<Form-item prop="scheme" style="width:200px;display:inline-block">
						<Select v-model="form.scheme" placeholder="请选择方案" transfer>
							<Option value="扩展版（50+5万）">扩展版（50+5万）</Option>
							<Option value="扩展版（80+10万）">扩展版（80+10万）</Option>
							<Option value="扩展版（100+15万）">扩展版（100+15万）</Option>
						</Select>
					</Form-item>
				</Form>
				<Button type="primary" @click="sub">立即购买</Button>
			</div>
		</div>
	</div>
	<div class="detail" ref="case">
		<div class="detail-title">方案简介</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p>本方案适用人员为日日顺物流签约车队司机，产品具体方案见下：</p>
			</div>
			<div class="center">
				<table class="productDetail-table sm">
					<thead>
						<tr>
							<th width="15%">项目</th>
							<th width="15%">计划一</th>
							<th width="15%">计划二</th>
							<th width="15%">计划三</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td>身故/伤残</td>
							<td>50万</td>
							<td>80万</td>
							<td>100万</td>
						</tr>
						<tr>
							<td>医疗费用</td>
							<td>5万</td>
							<td>10万</td>
							<td>15万</td>
						</tr>
						<tr>
							<td>误工费</td>
							<td colspan="3">200元/天，最高给付180天，免赔3天</td>
						</tr>
						<tr>
							<td>法律费用</td>
							<td colspan="3">每人死亡伤残赔偿限额的10%</td>
						</tr>
						<tr>
							<td>保费</td>
							<td>700元/座/年</td>
							<td>850元/座/年</td>
							<td>1000元/座/年</td>
						</tr>
						<tr>
							<td>特别约定</th>
							<td colspan="3" align="left">
								1、不记名随车投保，雇员年龄16-65周岁；<br>
								2、医疗费部分免赔100元；<br>
								3、误工费免赔3天；<br>
								4、本保单固定交通工具为车牌号{… }、车架号{…}、发动机号{…}的车辆；被保险人雇员驾驶其他车辆所发生的人身伤亡与财产损失为本保单除外责任；<br>
								5、本保单仅承保被保险人的雇员在驾驶或者乘坐本保单约定的车辆时，因遭受意外事故或患与工作有关的国家规定的职业性疾病所致伤、残或死亡所致损失；<br>
								6、本保单承保X人，若出险时车上雇员人数超过X人，则按照投保人数与实际人数之比例进行比例赔付。<br>
								7、被保险人雇员无证驾驶、酒后驾车、毒驾、驾驶无有效行驶证的机动车期间发生的意外伤害事故不属于本保险责任范围；<br>
								8、兹经合同双方同意，被保险人必须在知道或应当知道保险事故发生后的48小时内（或保单约定的时间内）向保险人报案，因延迟报案影响保险人查勘、定损的，保险人对于无法核实的部分不承担赔偿责任。本特别约定与主险条款内容相悖之处，以本特别约定为准；未尽之处，以主险条款为准；<br>
								9、被保险人的雇员包括与被保险人有雇佣关系的司机、随车人员，以及被保险人自雇的情形。<br>
								10、本保单扩展随车人员装卸货物过程中遭受的意外伤害损失。<br>
								------<br>
								扩展方案部分：<br>
								11、本保单扩展24小时A条款，具体释义为：被保险人的雇员在道路运输期间为维护本保单约定车辆继续运行（仅包括加油、加水、故障修理、换胎、整理篷布、休息）的临时停放期间因为工作原因遭受意外伤害事故所致死亡、残疾所致损失，保险人依据约定在责任限额内赔偿。<br>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="detail-main-title">保险方案说明：</div>
			<div class="detail-main-text">
				<p><b>1、本保险方案由中国平安财产保险股份有限公司提供。</b></p>
				<p><b>2、保险期限说明：</b>本保单默认保险期限一年，可按月申请，不足1月的按1月计算，短期费率如下</p>
				<div class="center">
					<table class="productDetail-table">
						<thead>
							<tr>
								<th>保险期间<br>（月数）</th>
								<th>1个月</th>
								<th>2个月</th>
								<th>3个月</th>
								<th>4个月</th>
								<th>5个月</th>
								<th>6个月</th>
								<th>7个月</th>
								<th>8个月</th>
								<th>9个月</th>
								<th>10个月</th>
								<th>11个月</th>
								<th>12个月</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="firstRow">年费率的比例<br>（％）</td>
								<td class="pd0">10%</td>
								<td class="pd0">20%</td>
								<td class="pd0">30%</td>
								<td class="pd0">40%</td>
								<td class="pd0">50%</td>
								<td class="pd0">60%</td>
								<td class="pd0">70%</td>
								<td class="pd0">80%</td>
								<td class="pd0">85%</td>
								<td class="pd0">90%</td>
								<td class="pd0">95%</td>
								<td class="pd0">100%</td>
							</tr>
						</tbody>
					</table>
				</div>
				<p><b>3、身故赔偿金</b></p>
				<p>被保险人的雇员在其雇佣期间因从事保险合同所载明的被保险人的工作而遭受意外事故或患与工作有关的国家规定的职业性疾病所致死亡，按照保险合同约定的每人死亡伤残赔偿限额赔偿死亡赔偿金。</p>
				<p><b>4、伤残赔偿金</b></p>
				<p>根据伤残鉴定机构出具的伤残程度鉴定书，按每人死亡伤残赔偿限额及本条款附录约定的“伤残等级赔偿限额比例表”规定的比例计算伤残赔偿限额。</p>
				<p>伤残等级赔偿限额比例表</p>
				<div class="center">
					<table class="productDetail-table">
						<thead>
							<tr>
								<th>伤残等级</th>
								<th>一级</th>
								<th>二级</th>
								<th>三级</th>
								<th>四级</th>
								<th>五级</th>
								<th>六级</th>
								<th>七级</th>
								<th>八级</th>
								<th>九级</th>
								<th>十级</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td class="firstRow">占明细表所列<br>责任限额之比率</td>
								<td class="pd0">100%</td>	
								<td class="pd0">90%</td>	
								<td class="pd0">80%</td>	
								<td class="pd0">70%</td>	
								<td class="pd0">60%</td>	
								<td class="pd0">50%</td>	
								<td class="pd0">40%</td>	
								<td class="pd0">30%</td>	
								<td class="pd0">20%</td>	
								<td class="pd0">10%</td>	
							</tr>
						</tbody>
					</table>
				</div>
				<p>① 当同一保险事故造成两处或两处以上伤残时，应首先对各处伤残程度分别进行评定，如果几处伤残等级不同，以最重的伤残等级作为最终的评定结果；</p>
				<p>② 如果两处或两处以上伤残等级相同，伤残等级在原评定基础上最多晋升一级。但无论如何伤残等级不得高于“伤残等级赔偿限额比例表”种所规定的一级。</p>
				<p><b>5、医疗费用</b></p>
				<p>保险人负责赔偿实际支出的按照就诊地社会医疗保险主管部门规定可报销的、必要的、合理的医疗费用。如果已从其他途径获得补偿的，保险人只承担就诊地社会医疗保险主管部门规定可报销的、必要的、合理医疗费用剩余部分的保险责任。除紧急抢救外，受伤雇员均应在符合本条款释义的医院就珍。</p>
				<p><b>6、法律诉讼费用</b></p>
				<p>保险事故发生后，被保险人因保险事故而被提起仲裁或者诉讼得，对应由被保险人支付得仲裁或诉讼费用以及事先经保险人书面同意支付得其他必要的、合理的法律费用，保险人按照本保险合同约定也负责赔偿。</p>
				<p><b>7、附加48小时猝死条款</b></p>
				<p>扩展在工作时间和工作岗位，突发疾病死亡或在48小时内经抢救无效死亡。</p>
				<p><b>8、附加24小时意外险</b></p>
				<p>被保险人的雇员在道路运输期间为维护本保单约定车辆继续运行（仅包括加油、加水、故障修理、换胎、整理篷布、休息）的临时停放期间因为工作原因遭受意外伤害事故所致死亡、残疾所致损失，保险人依据约定在责任限额内赔偿。</p>
			</div>
		</div>
	</div>
	<div class="detail" ref="claim">
		<div class="detail-title">理赔流程</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p><b>1、报案</b></p>
				<p>全国报案电话：0532-88931683（工作日9：00-17：30），其他时间拨打13375587300进行报案。</p>
				<p>邮箱：zhengxn.qdkt@haier.com</p>
				<p><b>2、理赔资料准备</b></p>
				<p>① 单位事故经过说明</p>
				<p>② 索赔申请书（单位盖章）</p>   
				<p>③ 赔款帐号信息，收款人身份信息，单位营业执照；</p>
				<p>④ 一次性索赔说明、未在第三方或其他保险公司获得赔偿的承诺书（客户签章）</p>
				<p>⑤ 死者身份证复印件（正反面）</p>
				<p>⑥ 劳动合同复印件加盖公章</p>
				<p>⑦ 赔付意向及权益转让书（单位盖章）</p>
				<p>⑧ 员工考勤记录、发薪证明或派遣公出单，派遣员工提供派遣协议</p>
				<p>⑨ 营业执照复印件与法人身份证资料（索赔金额大于1万元的案件需提供）</p>
				<p><b>死亡案件另需提供：</b></p>
				<p>① 死亡证明，火化证明，户口注销证明</p>
				<p>② 亲属关系证明及身份证明（如供养关系证明、户口本等及家属身份证正反面）</p>
				<p>③ 医院抢救记录</p>
				<p>④ 双方赔偿协议（双方签章、列明赔偿项目及各项金额）、调解书</p>
				<p>⑤ 赔偿凭证（证明已支付给伤者相应费用的证明），如单位财务的转帐凭证、银行转账单证，或转账家属授权书</p>
				<p>⑥ 无社保员工提供无社保证明（单位承诺书，社保局无社保证明）</p>
				<p>⑦ 警方证明（客户已报警）；</p>
				<p><b>3、理赔手续</b></p>
				<p>电子版理赔材料发送至邮箱到zhengxn.qdkt@haier.com，理赔专员将在1个工作日内答复，并指导您补充齐全材料邮寄，协助您向保险公司申请理赔</p>
				<p><b>4、审核结案</b></p>
				<p>通过理赔绿色通道帮助您同保险公司交涉，确认是否保险责任，督促保险公司尽快结案。材料齐全最快3个工作日。</p>
			</div>
		</div>
	</div>
	<div class="detail" ref="question">
		<div class="detail-title">常见问题</div>
		<div class="detail-main">
			<div class="detail-main-text">
				<p><b>1、产品优势有哪些？</b></p>
				<p><b>答：</b>
				保费低：日日顺专属价，保费仅是市场同内容产品价格的6折。<br>
				保额高：物流行业同类产品保额能到80-100万的极少，即使有保费也在千元以上。<br>
				保障全：除常规责任外扩展猝死责任以及24小时意外，最大限度规避企业风险、展现企业关怀。<br>
				医疗足：据保险业人伤数据分析，工伤常见案例平均医疗费分别为手臂骨折2万、腿部骨折5万、腰椎部骨伤费用或接近10万元。
				</p>
				<p><b>2、投保此款保险产品有什么好处？</b></p>
				<p><b>答：</b>此产品为雇主责任险，转嫁了企业风险，减轻了雇主的经济责任。保险赔偿金可首位赔给企业，经企业授权也可直接赔给受害人。</p>
				<p><b>3、企业雇佣的兼职可以投保么？</b></p>
				<p><b>答：</b>可承保临时工等企业合法用工范畴内的员工，限定为货车司机或随车人员。</p>
				<p><b>4、人员离职或增减能否处理？</b></p>
				<p><b>答：</b>按车投保方案无法进行人员替换或车辆替换。</p>
				<p><b>5、上下班路上出交通事故可以赔么？</b></p>
				<p><b>答：</b>以劳动部门出具的工伤认定书、交通管理部门出具的责任认定书为理赔依据。</p>
				<p><b>6、员工平时生病就诊，能不能拿来理赔？</b></p>
				<p><b>答：</b>不能。该方案仅针对工伤意外给予保障。如果员工在上下班途中发生碰撞或摔伤，相关就诊费用是可以申请理赔的，但是员工若是因为疾病（感冒、发烧等）发生的就诊费用，是不在承保范围之内的，故不予理赔。</p>
				<p><b>7、哪些费用可以理赔？</b></p>
				<p><b>答：</b>社保范围内的费用可递交至保险公司申请理赔。对于统筹支付和附加支付的相关费用，保险公司不予赔付。</p>
				<p><b>8、出险后，就医医院是否有限制？</b></p>
				<p><b>答：</b>出险请至二级及以上公立医院就诊。县、市、省级公立医院一般都属于二级或以上医院，乡镇卫生院一般属于一级或未评级医院。</p>
				<br>
				<br>
			</div>
		</div>
	</div>
</div>
</template>
<script>
export default {
	data () {
		return {
			productCode:'TRUCK_EMPLOYERS_LIABILITY_INSURANCE_WITH_TRUCK',
			bizId:'TRUCK_EMPLOYERS_LIABILITY_INSURANCE',
			form:{
				code:'',
				scheme:''
			},
			rules:{
				code:[{required:true,message:'请输入V码或9码',trigger:'blur'}],
				scheme:[{required:true,message:'请选择方案',trigger:'change'}]
			},
			tabName:'case',
			fixed:false,
		}
	},
	mounted() {
		this.$nextTick(()=>{
			window.addEventListener("scroll",this.handleScroll); 
		})
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll)
	},
	methods:{
		// 提交
		sub() {
			this.$refs.fixedForm.validate()
			this.$refs.form.validate(valid=>{
				if(valid){
					this.$axios.get('/broker/enterprise/preVerify',{
						bizCode:this.form.code,
						bizId:this.bizId
					}).then(applicantId=>{
						this.$axios.post(`/broker/insurance/application/apply/briefVerify.json`,{
							bizId:this.bizId,
							productCode:this.productCode,
							applicantIdList:[
								{value:applicantId}
							]
						}).then(res=>{
							this.$router.push(`/truck-employer/fillin/car?code=${this.form.code}&scheme=${encodeURIComponent(this.form.scheme)}`)
						})
					})
				}
			})
		},
		// tab切换
		tabChange(val){
			this.$refs[val].scrollIntoView()
		},
		// 监听滚动
		handleScroll() {
			//获取滚动时的高度
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > this.$refs.tabs.offsetTop) {
				this.fixed=true;
			}else{
				this.fixed=false;
			}
		}
	}
}
</script>
<style scoped lang="less">
	.main{
		margin-bottom: 30px;
	}
	.pb50{
		padding-bottom: 50px;
	}
	.red{
		color: red;
	}
	.banner-container{
		position: absolute;
		font-size: 14px;
		text-align:center;
		top: 0;
		bottom: 0;
		left:0;
		color:#333;
		background: rgba(255,255,255,0.7);
		padding:40px 0;
		width: 415px;
		.notes{
			margin-top: 10px;
		}
		&-title{
			font-size: 30px;
		}
		&-case{
			font-size: 36px;
			line-height: 2;
			color: #318af0;
		}
		&-desc{
			font-size: 18px;
		}
		&-input{
			width:240px;
			margin:10px auto 0;
			text-align: left;
		}
		&-btn{
			margin-top: 30px;
			a{
				width:240px;
			}
		}
	}
	.detail-title{
		font-size: 30px;
	}
	.detail-main{
		.center{
			font-size: 0;
		}
		&-title,&-text{
			padding-left: 20px;
		}
		&-title{
			font-size: 18px;
		}
		&-text{
			line-height:2;
		}
	}
	.tabs{
		display: block;
		height: 46px;
		&-container{
			padding: 10px 10px 0;
			background: #fff;
			height: 46px;
			overflow: hidden;
			position: relative;
			&-form{
				position: absolute;
				right: 10px;
				top: 5px;
				button{
					display: inline-block;
				}
			}
		}
		.fixed{
			position: fixed;
			top: 0;
			left: 0;
			right: 0;
			margin: auto;
			width: 1200px;
		}
	}

	.productDetail-table.sm{
		font-size: 13px;
		.fs16{
			font-size: 16px;
		}
		td{
			padding:8px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/truckEmployer/car/Index.vue